// extracted by mini-css-extract-plugin
export var courseRegistration = "CourseRegistration-module--courseRegistration--jI8RE";
export var courseNameContainer = "CourseRegistration-module--courseNameContainer--20Z2j";
export var courseName = "CourseRegistration-module--courseName--2UHNH";
export var tabs = "CourseRegistration-module--tabs--SWOM8";